import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { Toaster } from "sonner";

import "@/App.css";
import AuthGuard from "@/components/AuthGuard";
import AuthCallback from "@/pages/AuthCallback";
import JudgeWorkspace from "@/pages/JudgeWorkspace";
import HistoryPage from "@/pages/HistoryPage";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PilotClaimPage from "@/pages/PilotClaimPage";
import ProUpgrade from "@/pages/ProUpgrade";
import ProSettingsPage from "@/pages/ProSettingsPage";
import OwnerDashboard from "@/pages/OwnerDashboard";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/pilot/claim" element={<PilotClaimPage />} />
      <Route
        path="/"
        element={
          <AuthGuard>
            <JudgeWorkspace />
          </AuthGuard>
        }
      />
      <Route
        path="/pro"
        element={
          <AuthGuard>
            <ProUpgrade />
          </AuthGuard>
        }
      />
      <Route
        path="/history"
        element={
          <AuthGuard>
            <HistoryPage />
          </AuthGuard>
        }
      />
      <Route
        path="/settings"
        element={
          <AuthGuard>
            <ProSettingsPage />
          </AuthGuard>
        }
      />
      <Route
        path="/payment/success"
        element={
          <AuthGuard>
            <PaymentSuccess />
          </AuthGuard>
        }
      />
      <Route
        path="/owner-dashboard"
        element={
          <AuthGuard>
            <OwnerDashboard />
          </AuthGuard>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
